// hooks/useAuth.js
import { useState, useEffect, useCallback } from 'react';

const API_URL = '';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = useCallback(async (username, password) => {
    const res = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Login failed');
    localStorage.setItem('onbank_access_token', data.accessToken);
    localStorage.setItem('onbank_refresh_token', data.refreshToken);
    localStorage.setItem('onbank_user', JSON.stringify(data.user));
    setToken(data.accessToken);
    setUser(data.user);
    return data.user;
  }, []);

  const register = useCallback(async (formData) => {
    const res = await fetch(`${API_URL}/api/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Registration failed');
    localStorage.setItem('onbank_access_token', data.accessToken);
    localStorage.setItem('onbank_refresh_token', data.refreshToken);
    localStorage.setItem('onbank_user', JSON.stringify(data.user));
    setToken(data.accessToken);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await fetch(`${API_URL}/api/auth/logout`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } }); } catch {}
    localStorage.clear();
    setUser(null);
    setToken(null);
  }, [token]);

  const refreshToken = useCallback(async () => {
    const refresh = localStorage.getItem('onbank_refresh_token');
    if (!refresh) return false;
    try {
      const res = await fetch(`${API_URL}/api/auth/refresh`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken: refresh }),
      });
      const data = await res.json();
      if (res.ok && data.accessToken) {
        localStorage.setItem('onbank_access_token', data.accessToken);
        setToken(data.accessToken);
        return true;
      }
    } catch {}
    return false;
  }, []);

  useEffect(() => {
    const t = localStorage.getItem('onbank_access_token');
    const u = localStorage.getItem('onbank_user');
    if (t && u) { setToken(t); setUser(JSON.parse(u)); }
    setLoading(false);
  }, []);

  return { user, token, loading, login, register, logout, refreshToken, isAuthenticated: !!user };
}
